import { useEffect, useState } from "react";
import { getNextRelease } from "../../api/Get";
import { CalendarOutlined } from "@ant-design/icons";
import { Card, List, Space, Tag, Typography } from "antd";

const { Text, Title } = Typography;

const NextReleases = () => {
  const [nextReleases, setNextReleases] = useState([]);

  const loadNextRelease = async () => {
    const res = await getNextRelease();
    console.log(res);
    if (res.releases) setNextReleases(res.releases);
  };

  const renderRelease = (release) => {
    console.log(release);
    return (
      <List.Item>
        <Card title={release.serieName} bordered={false}>
          <Space direction="vertical">
            <Space>
              <Tag icon={<CalendarOutlined />} color="#120D35">
                {release.publicationDate}
              </Tag>
              {release.statutAT ? (
                <Tag
                  color={
                    release.statutAT === "Prête à être publiée"
                      ? "success"
                      : "processing"
                  }
                >
                  {release.statutAT}
                </Tag>
              ) : (
                <Tag color={"error"}>Aucun statut</Tag>
              )}
            </Space>

            <Text type="secondary">{`${release.collectionName}`}</Text>
            <Text type="secondary">{`${release.maisonEditionName}`}</Text>
          </Space>
        </Card>
      </List.Item>
    );
  };

  useEffect(() => {
    loadNextRelease();
  }, []);

  return (
    <div style={{ marginBottom: 40 }}>
      <Title level={3}>Prochaines sorties de la semaine</Title>
      <List
        itemLayout="horizontal"
        grid={{ gutter: 16, column: 2 }}
        dataSource={nextReleases}
        renderItem={renderRelease}
      />
    </div>
  );
};

export default NextReleases;
